.line {
  padding: 10px 14px;
  border-bottom: 1px solid var(--line);
}

/* The Charts toggle: a chevron button at the right end of the line. */
.charts {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--h-ctl);
  padding: 0 10px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
  background: var(--panel);
  color: var(--accent);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.charts:hover {
  border-color: var(--accent-line);
  background: var(--accent-w);
}

.charts:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.charts svg {
  transition: transform var(--dur-2) var(--ease-std);
}

.up {
  transform: rotate(180deg);
}

@media (prefers-reduced-motion: reduce) {
  .charts svg {
    transition: none;
  }
}
